import {gql} from '@apollo/client';

import PaymentsSourceFragment from 'web-app/api/shared-fragments/payments-source';
import {BillPayerSynchronizationStatus} from 'web-app/api/shared-fragments/integration-sync-status';

export const GetAnonymousBillPayerPaymentSourceV2 = gql`
    query GetAnonymousBillPayerPaymentSourceV2($billPayerId: BillPayerId!) {
        payments {
            getBillPayerSource(billPayerId: $billPayerId) {
                anonymous {
                    title
                    owner {
                        id
                        name {
                            fullName
                        }
                    }
                }
            }
            personal {
                associatedBillPayers {
                    billPayerId
                    automaticPaymentsDate
                    automaticPaymentsDetails {
                        relativeBillingDate
                        exactDay
                        dayOfTheWeek
                    }
                }
            }
        }
    }
`;

export const GetCurrentBillPayerPaymentSourceV2 = gql`
    query GetCurrentBillPayerPaymentSourceV2($billPayerId: BillPayerId!, $isInternal: Boolean) {
        payments {
            getBillPayerSource(billPayerId: $billPayerId, isInternal: $isInternal) {
                source {
                    ...PaymentsSource
                }
                anonymous {
                    title
                    owner {
                        id
                        name {
                            fullName
                        }
                    }
                    status
                }
            }
            personal {
                associatedBillPayers {
                    billPayerId
                    automaticPaymentsDate
                    automaticPaymentsDetails {
                        relativeBillingDate
                        exactDay
                        dayOfTheWeek
                    }
                }
            }
        }
    }

    ${PaymentsSourceFragment}
`;

export const ClearBillPayerPaymentSourceV2 = gql`
    mutation ClearBillPayerPaymentSourceV2($billPayerId: BillPayerId!) {
        payments {
            clearBillPayer(billPayerId: $billPayerId)
        }
    }
`;

export const GetBillPayerIntegrationSyncStatus = gql`
    query GetBillPayerIntegrationSyncStatus($billPayerId: BillPayerId!) {
        billPayers {
            byBillPayerIds(billPayerIds: [$billPayerId]) {
                results {
                    billPayer {
                        billPayerId
                    }
                    behaviors {
                        behaviorId
                        __typename
                        ... on BehaviorCanSyncExternally {
                            status {
                                ...BillPayerSynchronizationStatus
                            }
                        }
                    }
                }
            }
        }
    }

    ${BillPayerSynchronizationStatus}
`;

export const ResyncBillPayer = gql`
    mutation ResyncBillPayer($resyncInfo: BillPayerExportInputType!) {
        finance {
            integration {
                export {
                    billPayers(billPayers: [$resyncInfo]) {
                        details {
                            billPayerId
                            status {
                                ...BillPayerSynchronizationStatus
                            }
                        }
                    }
                }
            }
        }
    }

    ${BillPayerSynchronizationStatus}
`;
export const GetBillPayerAutomaticInvoicingConfig = gql`
    query GetBillPayerAutomaticInvoicingConfig($siteSetId: InstitutionSetId!, $billPayerIds: [BillPayerId!]!) {
        finance {
            invoices {
                automaticInvoicing {
                    billPayerAutomaticInvoicingConfig(siteSetId: $siteSetId, billPayerIds: $billPayerIds) {
                        isEnabled
                        billPayerId
                        enabledSchedule
                        nextInvoice
                        availableSchedules
                    }
                }
            }
        }
    }
`;

export const SetBillPayerAutomaticInvoicingConfig = gql`
    mutation SetBillPayerAutomaticInvoicingConfig(
        $siteSetId: InstitutionSetId!
        $billPayerIds: [BillPayerId!]!
        $schedule: AutomaticInvoicingOccurrence
    ) {
        finance {
            invoices {
                automaticInvoicing {
                    setBillPayerAutomaticInvoicingConfig(
                        siteSetId: $siteSetId
                        billPayerIds: $billPayerIds
                        schedule: $schedule
                    ) {
                        isEnabled
                        billPayerId
                        enabledSchedule
                        nextInvoice
                        availableSchedules
                    }
                }
            }
        }
    }
`;

export const GetBillPayerShowLimitedParentAccessNotice = gql`
    query GetBillPayerShowLimitedParentAccessNotice($billPayerId: BillPayerId!) {
        billPayers {
            invoiceRecipients(billPayerId: $billPayerId) {
                showLimitedContactRoleWarning
            }
        }
    }
`;
